var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("版权所有：东北抗日义勇军纪念馆")]),_c('p',[_vm._v("备案号：辽ICP备2023011290号")]),_c('p',[_vm._v("地址：辽宁省本溪市桓仁满族自治县桓仁镇东关村1组")])])
}]

export { render, staticRenderFns }